import { format, type Locale } from 'date-fns';

/** Display format of every membership date; rendered in the device's local time. */
export const MEMBERSHIP_DATE_FORMAT = 'd MMM yyyy';

/** Formatting the domain needs but must not implement, injected by the UI. */
export interface MembershipFormatters {
  /** Formats an amount in minor units in the given currency (any case). */
  money: (amountMinor: number, currency: string) => string;
  /** Formats an ISO timestamp as a local date; `null` when absent or unparseable. */
  date: (iso: string | null | undefined) => string | null;
}

/** Formats an ISO timestamp as a local date, or `null` when it is missing or invalid. */
export const formatMembershipDate = (
  iso: string | null | undefined,
  locale?: Locale,
): string | null => {
  if (!iso) {
    return null;
  }
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) {
    return null;
  }
  return format(date, MEMBERSHIP_DATE_FORMAT, { locale });
};
